export default function ErrorPage() {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="text-xl font-bold text-slate-400 m-10">
        Oops, this is an error.
      </div>
    </div>
  );
}
